
import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Settings, Webhook } from "lucide-react";
import WebhookManagement from "./WebhookManagement";
import AppSettingsManagement from "./AppSettingsManagement";

const EnhancedWebhookManagement = () => {
  const [activeTab, setActiveTab] = useState("webhooks");

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-2 mb-6">
        <Settings className="h-6 w-6" />
        <h2 className="text-2xl font-bold">System Management</h2>
      </div>

      <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
        <TabsList className="grid w-full grid-cols-2">
          <TabsTrigger value="webhooks" className="flex items-center gap-2">
            <Webhook className="h-4 w-4" />
            Webhook Management
          </TabsTrigger>
          <TabsTrigger value="app-settings" className="flex items-center gap-2">
            <Settings className="h-4 w-4" />
            App Settings
          </TabsTrigger>
        </TabsList>

        <TabsContent value="webhooks" className="mt-6">
          <WebhookManagement />
        </TabsContent>

        <TabsContent value="app-settings" className="mt-6">
          <AppSettingsManagement />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default EnhancedWebhookManagement;
